import { Client, QueryParameters } from 'algoliasearch';

export interface AlgoliaQuery {
  indexName?: string;
  query: string;
  params: QueryParameters;
}

type AlgoliaInitializer = () => Promise<Client>;

interface Options {
  initializer: AlgoliaInitializer;
  index: string;
}

export default function createAlgoliaService({ initializer, index }: Options) {
  let initializedP: Promise<Client> | null;

  const init = () => {
    if (initializedP) {
      return initializedP;
    }

    initializedP = initializer();

    return initializedP;
  };

  return {
    searchListings: (params: AlgoliaQuery[], customIndex?: string) =>
      init().then(client => {
        return client.search(
          params.map(param => ({
            ...param,
            indexName: customIndex || index,
          })),
        );
      }),
  };
}
